import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["embedId", "flowValidation", "requestFlowValidationObject"];
import { GYPSUM } from 'HubStyleTokens/colors';
import { useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { useLocation, withRouter } from 'react-router-dom';
import { compose } from 'redux';
import styled from 'styled-components';
import * as flowActions from 'automation-ui-canvas/actions/FlowActions';
import UILoadingSpinnerCentered from 'automation-ui-canvas/components/common/UILoadingSpinnerCentered';
import ErrorMessage from 'automation-ui-canvas/components/errors/ErrorMessage';
import DataSourcesProviderWrapper from 'automation-ui-canvas/containers/DataSourcesProviderWrapper';
import { getFlowValidation } from 'automation-ui-canvas/selectors/flowSelectors';
import { useGetFlowById } from 'automation-ui-canvas/queries/flowQueries';
import { useGetTemplateById } from 'automation-ui-canvas/queries/templateQueries';
import { getEmbedId } from 'automation-ui-canvas/selectors/embedSelectors';
import UpdateMetadata from 'automation-ui-canvas/flow/records/properties/UpdateMetadata';
import Flow from 'automation-ui-canvas/flow/records/Flow/Flow';
import { parseLocation } from 'automation-ui-routing/utils';
import * as SourceApps from 'automation-ui-source-apps/constants/SourceApps';
import { sendMessageToParent } from 'ui-addon-automation-embed/embedUtils';
import PostMessageTypes from 'ui-addon-automation-embed/PostMessageTypes';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledFlowContainer = styled.div.withConfig({
  displayName: "FlowCanvasEmbedPreviewDecorator__StyledFlowContainer",
  componentId: "sc-12z6nni-0"
})(["background:", ";height:650px;width:100%;overflow:auto;"], GYPSUM);
const FlowCanvasEmbedPreviewDecorator = WrappedComponent => {
  const FlowCanvasEmbedPreviewContainer = _ref => {
    let {
        embedId,
        flowValidation,
        requestFlowValidationObject
      } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);
    const location = useLocation();
    const scrollElementRef = useRef(null);
    const parsedQuery = parseLocation(location);
    const flowId = parseInt(parsedQuery.flowId, 10) || undefined;
    const templateId = parseInt(parsedQuery.templateId, 10) || undefined;
    const {
      data: flowByIdData,
      error: flowError,
      loading: flowLoading
    } = useGetFlowById(flowId);
    const flowData = flowByIdData === null || flowByIdData === void 0 ? void 0 : flowByIdData.flowById;
    const {
      data: templateData,
      error: templateError,
      loading: templateLoading
    } = useGetTemplateById({
      templateId
    });
    const template = templateData === null || templateData === void 0 ? void 0 : templateData.templateById;
    let flow;
    if (template) {
      flow = new Flow(Object.assign({}, template.flow, {
        // templates do not have create/update metadata and is required for rendering some canvas components
        createMetadata: new UpdateMetadata(),
        updateMetadata: new UpdateMetadata()
      }));
    } else if (flowData) {
      flow = flowData;
    }
    useEffect(() => {
      // flow validation only applies to existing workflows - templates' flow shape does not exist yet
      if (flow && !template) {
        requestFlowValidationObject(flow);
      }
      if (flow || template || templateError || flowError) {
        sendMessageToParent({
          type: PostMessageTypes.EMBEDDED_FLOW_LOADED,
          embedId
        });
      }
    }, [flow, template, templateError, flowError]); // eslint-disable-line react-hooks/exhaustive-deps

    if (flowLoading || templateLoading) {
      return /*#__PURE__*/_jsx(StyledFlowContainer, {
        children: /*#__PURE__*/_jsx(UILoadingSpinnerCentered, {})
      });
    }
    if (!flow || flowError || templateError) {
      return /*#__PURE__*/_jsx(StyledFlowContainer, {
        className: "flex-grow-1 justify-center",
        children: /*#__PURE__*/_jsx(ErrorMessage, {})
      });
    }
    return /*#__PURE__*/_jsx(DataSourcesProviderWrapper, {
      flowId: flow.getFlowId(),
      sourceAppId: SourceApps.WORKFLOWS_APP,
      children: /*#__PURE__*/_jsx(StyledFlowContainer, {
        ref: scrollElementRef,
        children: /*#__PURE__*/_jsx(WrappedComponent, Object.assign({
          disableMinimapFlowCanvasOverride: false,
          flow: flow,
          flowValidation: flowValidation,
          isEmbedded: true,
          showMinimapFlowCanvasOverride: false,
          embedId: embedId,
          requestFlowValidationObject: requestFlowValidationObject
        }, props))
      })
    });
  };
  return compose(withRouter, connect((state, {
    location
  }) => {
    const embedId = getEmbedId(state);
    const parsedQuery = parseLocation(location);
    const flowId = parseInt(parsedQuery.flowId, 10) || null;
    const flowValidation = getFlowValidation(flowId)(state);
    return {
      embedId,
      flowValidation,
      flowId
    };
  }, {
    requestFlowValidationObject: flowActions.requestFlowValidationObject
  }))(FlowCanvasEmbedPreviewContainer);
};
export default FlowCanvasEmbedPreviewDecorator;